<template>
    <div>
        <slot :months="months" :showPreviousMonthButton="showPreviousMonthButton" :showNextMonthButton="showNextMonthButton" :previousMonth="previousMonth" :nextMonth="nextMonth" :currentMonth="currentMonth"></slot>
    </div>
</template>

<script>
'use strict'

import { first, last } from 'lodash';
import { format } from 'date-fns-tz';
import { add, addDays, endOfMonth, startOfMonth, sub } from 'date-fns';
import zonedDate from '../utils/zoned-date';
import { computed, defineComponent, ref } from 'vue';

const now = format(zonedDate(), 'yyyy-MM-dd');

export default defineComponent({
    name: 'DateSelector',
    props: {
        items: {
            type: Array,
            required: true,
        },
        aslist: {
            type: Boolean,
            required: true,
        }
    },
    setup(props) {
        const currentMonth = ref(null);
        const showPreviousMonthButton = ref(false);
        const showNextMonthButton = ref(false);
        const dates = ref([]);

        const months = computed(() => {
            if (!props.items || !Object.keys(props.items).length) {
                return [];
            }

            dates.value = props.items.map(p => format(p.performancedate, 'yyyy-MM-dd'));

            const firstDate = startOfMonth(zonedDate(dates.value[0]));
            let testDate = firstDate;

            if (!props.aslist && !currentMonth.value) {
                currentMonth.value = testDate;
            }

            let lastDate = endOfMonth(zonedDate(dates.value[dates.value.length - 1]));
            const currentYear = format(new Date(), 'yyyy');

            if (!props.aslist) {
                showPreviousMonthButton.value = currentMonth.value > firstDate;
                showNextMonthButton.value = currentMonth.value < lastDate;

                testDate = startOfMonth(currentMonth.value);
                lastDate = endOfMonth(currentMonth.value);
            }

            const months = [];
            while(testDate < lastDate) {
                let month = months.find(month => month.month === format(testDate, 'MMMM') && month.year === format(testDate, 'yyyy'));
                if (!month) {
                    let padding = parseInt(format(testDate, 'e'));
                    // Week to start on Sunday so need to offset the padding
                    padding = padding <= 1 ?
                        padding + 6 :
                        padding - 1;
                    // So we don't end up with an empty first line
                    padding = padding === 7 ? 0 : padding;

                    month = {
                        year: format(testDate, 'yyyy'),
                        is_current_year: format(testDate, 'yyyy') === currentYear,
                        month: format(testDate, 'MMMM'),
                        days: Array(padding).fill({}),	// Pads the days at the begninning of the month
                    };
                    months.push(month);
                }
                const dateString = format(testDate, 'yyyy-MM-dd'); // `${testDate.getFullYear()}-${(testDate.getMonth() + 1).toString().padStart(2, '0')}-${testDate.getDate().toString().padStart(2, '0')}`;

                const day = {
                    day: format(testDate, 'd'),
                    today: dateString === now,
                    events: dates.value.indexOf(dateString) > -1,
                    date: dateString,
                };
                month.days.push(day);
                testDate = addDays(testDate, 1);
            }

            return months;
        });

        const previousMonth = (() => {
            currentMonth.value = sub(currentMonth.value, {months: 1});
        });

        const nextMonth = (() => {
            currentMonth.value = add(currentMonth.value, {months: 1});
        });

        return {
            months,
            currentMonth,
            showPreviousMonthButton,
            showNextMonthButton,
            previousMonth,
            nextMonth,
        };
    },
});
</script>
